export enum ButtonVariant {
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  transparentOutlined = 'transparentOutlined',
  transparent = 'transparent',
  transparentUnderlined = 'transparentUnderlined',
  error = 'error',
  success = 'success',
  iconButton = 'iconButton',
}

const buttonSchema = {
  text: {
    default: null,
    hover: null,
    disabled: null,
  },
  background: {
    default: null,
    hover: null,
    disabled: null,
  },
  border: null,
};

export const button: Record<ButtonVariant, typeof buttonSchema> = Object.values(
  ButtonVariant,
).reduce(
  (acc, variant) => {
    acc[variant] = buttonSchema;
    return acc;
  },
  {} as Record<ButtonVariant, typeof buttonSchema>,
);
